import { MEMBERSHIP_SKUS } from "../../../DiscoveryJourneyModal";
import type {
  AnniversaryGiftCardContentProps,
  GiftContentResponse
} from "./types";

export const anniversaryGiftCardContentPerMembership = ({
  anniversaryGift,
  currentMembershipSku
}: AnniversaryGiftCardContentProps): GiftContentResponse | null => {
  const commonContent = {
    imageUrl:
      "https://beautypie.bynder.com/m/6da42fe4807535d8/webimage-ANNIVERSARY_WEB.jpg",
    title: "Anniversary Gift"
  };

  if (anniversaryGift) {
    return {
      ...commonContent,
      description:
        "As a thank you for your loyalty, here's a special gift on us!"
    };
  }

  if (MEMBERSHIP_SKUS.membershipsWithPerks.includes(currentMembershipSku)) {
    return {
      ...commonContent,
      description:
        "You'll unlock a special gift on your Beauty Pie+ anniversary"
    };
  }

  if (MEMBERSHIP_SKUS.freeTrial.includes(currentMembershipSku)) {
    return {
      ...commonContent,
      description:
        "When you become a fully-fledged Beauty Pie+ member you'll unlock a gift on your anniversary each year"
    };
  }

  return null;
};
